import React, { FC, useMemo } from 'react'

import styled from 'styled-components'

import StandLarge from './StandLarge'
import StandMedium from './StandMedium'
import StandSmall from './StandSmall'

import { VideoData } from '../types'

const S = {
    Container: styled.div`
        display: block;
        width: 100%;
        height: 500px;
        padding: 30px 20px 110px;
        text-align: center;
    `,
}

export enum BoothTypes {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export interface BoothPreviewProps {
    boothBackground?: string
    boothLogo?: string
    boothType: BoothTypes
    color?: string
    video?: VideoData | undefined
}

const BoothPreview: FC<BoothPreviewProps> = ({
    boothBackground = null,
    boothLogo = null,
    boothType = null,
    color = '#ffffff',
    video = null,
}: BoothPreviewProps) => {
    const Stand = useMemo(() => {
        switch (boothType) {
        case BoothTypes.SMALL:
            return StandSmall
        case BoothTypes.MEDIUM:
            return StandMedium
        case BoothTypes.LARGE:
            return StandLarge
        default:
            return StandMedium
        }
    }, [boothType])

    return (
        <S.Container className="flex-grow-0 flex-grow-0">
            <Stand
                background={boothBackground}
                logo={boothLogo}
                color={color}
                video={video}
            />
        </S.Container>
    )
}

export default BoothPreview
